import { flow } from 'fp-ts/function';
import { get } from 'lodash/fp';
import { createSelector } from 'reselect';
import { getCurrentDateTimeLocalizationInfo } from '@mews-commander/core/legacy-globalization';
import { getStringProp } from '@mews/fp';
import { formatDateValue } from '@mews/framework';
import { createDateFormatPattern } from '@optimus-web/core';

export const getDateFormatPattern = flow(
    getCurrentDateTimeLocalizationInfo,
    get('dateFormat'),
    createDateFormatPattern
);

export const getDateValue = createSelector(
    [getStringProp('value'), getDateFormatPattern, getCurrentDateTimeLocalizationInfo],
    formatDateValue
);
